import { Button, media } from '@higo/ui';
import { MouseEvent, useCallback } from 'react';
import { useEditOrCloseVisitMutation } from '@higo/common/lib/features/ExaminationPage/hooks/queries/useEditOrCloseVisitMutation';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { getDashboardChildRoute, routes } from 'routes';

export type EditOrCloseVisitButtonProps = {
  visitId: number;
};

export const CloseVisitButton = ({ visitId }: EditOrCloseVisitButtonProps) => {
  const StyledButtonWrapper = styled('div')`
    display: inline;
    align-self: end;
    margin: 2rem 0 2rem auto;
  `;

  const StyledButton = styled(Button)`
    height: 1.5rem;
    width: 14.5rem;
    padding: 1rem 0.5rem;
    margin: 2rem 0 3rem 0;

    ${media.mobile.max} {
      margin: 3rem 0 1rem 1.5rem;
    }
  `;

  const { mutateAsync: closeVisit } = useEditOrCloseVisitMutation(visitId);
  const navigate = useNavigate();

  const handleClick = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      closeVisit('ENDED').then(() =>
        navigate(getDashboardChildRoute(routes.dashboard.liveVisits)),
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [visitId, closeVisit],
  );

  return visitId ? (
    <StyledButtonWrapper>
      <StyledButton
        size="small"
        color="secondary"
        // endIcon={<CloseIcon />}
        onClick={handleClick}
        id="close-visit-button"
      >
        End the visit
        {/* <FormattedMessage id="common.unassign" /> */}
      </StyledButton>
    </StyledButtonWrapper>
  ) : null;
};
